import { render, staticRenderFns } from "./AssignUser.vue?vue&type=template&id=12b50bea&scoped=true&"
import script from "./AssignUser.vue?vue&type=script&lang=js&"
export * from "./AssignUser.vue?vue&type=script&lang=js&"
import style0 from "./AssignUser.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AssignUser.vue?vue&type=style&index=1&id=12b50bea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b50bea",
  null
  
)

export default component.exports